import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  currentTheme: 'light',
  changeCurrentTheme: () => {},
});

export default function ThemeProvider({children}) {  
  const persistedTheme = localStorage.getItem('theme');
  const [theme, setTheme] = useState(persistedTheme || 'dark');

  const changeCurrentTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  let attribs = {};

  switch (window.location.hostname) {
    case 'kingpin.mindcore.es':
      attribs = { logo: '/mindcoretr.png', txtgray: "500" };
      break;
    case 'kingpin.multicomputos.com':
      attribs = { logo: '/multicomputos_logo.png', txtgray: "500" };
      break;
    case 'kingpin.thefinlabs.com':
      attribs = { logo: '/finlabs.webp', txtgray: "500" };
      break;
    default:
      attribs = { logo: '/mindcoretr.png', txtgray: "500" };
  }

  useEffect(() => {
    document.documentElement.classList.add('[&_*]:!transition-none');
    if (theme === 'light') {
      document.documentElement.classList.remove('dark');
      document.documentElement.style.colorScheme = 'light';
    } else {
      document.documentElement.classList.add('dark');
      document.documentElement.style.colorScheme = 'dark';
    }

    const transitionTimeout = setTimeout(() => {
      document.documentElement.classList.remove('[&_*]:!transition-none');
    }, 1);
    
    return () => clearTimeout(transitionTimeout);
  }, [theme]);

  return <ThemeContext.Provider value={{ currentTheme: theme, changeCurrentTheme, attribs }}>{children}</ThemeContext.Provider>;
}

export const useThemeProvider = () => useContext(ThemeContext);